import { fromJS } from 'immutable';
import { FETCH_USER_ATTRIBUTES_STARTED, FETCH_USER_ATTRIBUTES_SUCCEEDED, SET_HAS_SEEN_DEAL_STAGE_FORECAST_TOUR, SET_HAS_SEEN_FMO_MIGRATION_TOUR } from '../actions/ActionTypes';
import { STARTED, UNINITIALIZED, SUCCEEDED } from '../constants/RequestStatusTypes';
import { HAS_SEEN_DEAL_STAGE_FORECAST_TOUR, HAS_SEEN_FMO_MIGRATION_TOUR } from '../constants/SettingsTypes';
const initialState = fromJS({
  status: UNINITIALIZED,
  [HAS_SEEN_DEAL_STAGE_FORECAST_TOUR]: false,
  [HAS_SEEN_FMO_MIGRATION_TOUR]: false
});
export default function users(state = initialState, action) {
  switch (action.type) {
    case FETCH_USER_ATTRIBUTES_STARTED:
      {
        return state.merge({
          status: STARTED
        });
      }
    case SET_HAS_SEEN_DEAL_STAGE_FORECAST_TOUR:
      return state.set(HAS_SEEN_DEAL_STAGE_FORECAST_TOUR, true);
    case SET_HAS_SEEN_FMO_MIGRATION_TOUR:
      return state.set(HAS_SEEN_FMO_MIGRATION_TOUR, true);
    case FETCH_USER_ATTRIBUTES_SUCCEEDED:
      {
        const {
          payload
        } = action;
        return state.merge({
          [HAS_SEEN_DEAL_STAGE_FORECAST_TOUR]: payload.hasSeenDealStageForecastTour,
          [HAS_SEEN_FMO_MIGRATION_TOUR]: payload.hasSeenFmoMigrationTour,
          status: SUCCEEDED
        });
      }
    default:
      return state;
  }
}